// ===========================================
// CONSTANTES - NEW ONBOARDING
// ===========================================
import image1 from '../../../assets/images/image-onboarding-1.webp';
import image2 from '../../../assets/images/image-onboarding-3.webp';

export const STEPS = {
  USER_TYPE: 'USER_TYPE',
  // Flow Parent
  CHILD_INFO: 'CHILD_INFO',
  AVAILABILITY: 'AVAILABILITY',
  DURATION: 'DURATION',
  GOALS: 'GOALS',
  SOCIAL_PROOF: 'SOCIAL_PROOF',
  // Flow Élève
  STUDENT_NAME: 'STUDENT_NAME',
  STUDENT_CLASS: 'STUDENT_CLASS',
  STUDENT_INFO: 'STUDENT_INFO',
  PARENT_CONTACT: 'PARENT_CONTACT',
  // Commun
  SUCCESS: 'SUCCESS',
};

export const STEP_ORDER = [
  STEPS.USER_TYPE,
  STEPS.CHILD_INFO,
  STEPS.AVAILABILITY,
  STEPS.DURATION,
  STEPS.GOALS,
  STEPS.SOCIAL_PROOF,
  STEPS.SUCCESS,
];

// Flow spécifique pour les élèves (sans l'étape du nom car déjà renseigné à l'inscription)
export const STUDENT_STEP_ORDER = [
  STEPS.USER_TYPE,
  STEPS.STUDENT_CLASS,
  STEPS.STUDENT_INFO,
  STEPS.PARENT_CONTACT,
  STEPS.SUCCESS,
];

export const STEP_CONFIG = {
  [STEPS.USER_TYPE]: { number: 1, showProgress: false, message: '' },
  // Flow Parent (6 étapes)
  [STEPS.CHILD_INFO]: { number: 2, showProgress: true, message: 'Tu es sur la bonne voie 💪', totalSteps: 6 },
  [STEPS.AVAILABILITY]: { number: 3, showProgress: true, message: 'Tu es sur la bonne voie 💪', totalSteps: 6 },
  [STEPS.DURATION]: { number: 4, showProgress: true, message: 'Bravo, presque fini ! ✨', totalSteps: 6 },
  [STEPS.GOALS]: { number: 5, showProgress: true, message: 'Bravo, presque fini ! ✨', totalSteps: 6 },
  [STEPS.SOCIAL_PROOF]: { number: 6, showProgress: true, message: "C'est presque terminé ! 🎉", totalSteps: 6 },
  // Flow Élève (4 étapes - sans le nom)
  [STEPS.STUDENT_NAME]: { number: 1, showProgress: true, message: 'Excellent départ ! 🎯', totalSteps: 4 },
  [STEPS.STUDENT_CLASS]: { number: 1, showProgress: true, message: 'Excellent départ ! 🎯', totalSteps: 4 },
  [STEPS.STUDENT_INFO]: { number: 2, showProgress: true, message: 'Tu es sur la bonne voie 💪', totalSteps: 4 },
  [STEPS.PARENT_CONTACT]: { number: 3, showProgress: true, message: 'Bravo, presque fini ! ✨', totalSteps: 4 },
  [STEPS.SUCCESS]: { number: null, showProgress: false, message: '' },
};

export const USER_TYPES = [
  {
    id: 'parent',
    label: 'Je suis un parent',
    description: 'Je veux aider mon enfant à progresser',
    icon: 'user',
    emoji: '👨‍👩‍👧',
  },
  {
    id: 'eleve',
    label: "Je suis l'élève",
    description: 'Je veux améliorer mes résultats scolaires',
    icon: 'graduation',
    emoji: '🧑‍🎓',
  },
];

export const GENDERS = [
  { id: 'garcon', label: 'Garçon', emoji: '👦' },
  { id: 'fille', label: 'Fille', emoji: '👧' },
];


export const CLASSES = [
  'CI', 'CP', 'CE1', 'CE2', 'CM1', 'CM2',
  'Collège', 'Lycée', 'Préscolaire',
];

export const DIFFICULTIES = [
  { id: 'vision', label: 'Vision', emoji: '👓' },
  { id: 'audition', label: 'Audition', emoji: '👂' },
  { id: 'concentration', label: 'Concentration', emoji: '🧠' },
  { id: 'aucune', label: 'Aucune', emoji: '✅' },
];

export const AVAILABILITY_SLOTS = [
  { id: 'matin', label: 'Matin', time: '6h - 8h', icon: '☀️' },
  { id: 'midi', label: 'Pause midi', time: '12h - 14h', icon: '🌤️' },
  { id: 'apres-ecole', label: "Après l'école", time: '16h - 18h', icon: '🏫' },
  { id: 'soir', label: 'Soir', time: '19h - 21h', icon: '🌙' },
  { id: 'weekend', label: 'Week-end uniquement', time: 'Samedi & Dimanche', icon: '📅' },
];

export const DURATIONS = [
  { id: 5, label: '5 minutes', description: 'Idéal pour commencer', recommended: false },
  { id: 10, label: '10 minutes', description: 'Le plus populaire', recommended: true },
  { id: 15, label: '15 minutes', description: 'Résultats visibles plus vite', recommended: false },
  { id: 20, label: '20 minutes', description: 'Pour les plus motivés', recommended: false },
];

export const LEARNING_GOALS = [
  { id: 'lecture', label: 'Améliorer la lecture', icon: '📖' },
  { id: 'maths', label: 'Renforcer les mathématiques', icon: '🔢' },
  { id: 'devoirs', label: 'Mieux organiser les devoirs', icon: '⏰' },
  { id: 'autonomie', label: 'Rendre mon enfant plus autonome', icon: '✓' },
  { id: 'stress', label: 'Réduire le stress à la maison', icon: '😊' },
];

export const MAX_GOALS = 3;

export const BADGES = {
  unlocked: [
    {
      id: 'engage',
      label: 'Parent Engagé',
      description: 'Tu as complété le profil de ton enfant',
      color: 'green',
      icon: '🎯',
    },
    {
      id: 'organise',
      label: 'Parent Organisé',
      description: "Tu as défini un planning d'étude régulier",
      color: 'blue',
      icon: '📅',
    },
  ],
  locked: [
    {
      id: 'suiveur',
      label: 'Parent Suiveur',
      description: 'Lance ton premier diagnostic',
      icon: '📊',
    },
    {
      id: 'soutien',
      label: 'Parent Soutien',
      description: 'Aide ton enfant 7 jours de suite',
      icon: '💪',
    },
  ],
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Aminata D.',
    city: 'Dakar',
    improvement: '+100%',
    subject: 'lecture',
    before: '8/20',
    after: '16/20',
    duration: '6 semaines',
    quote: "Ma fille lisait difficilement. Aujourd'hui elle dévore des livres !",
    rating: 5,
    image: `${image1}`,
  },
  {
    id: 2,
    name: 'Kofi M.',
    city: 'Abidjan',
    improvement: '+133%',
    subject: 'maths',
    before: '6/20',
    after: '14/20',
    duration: '2 mois',
    quote: "Mon fils avait peur des maths. Maintenant c'est sa matière préférée !",
    rating: 5,
    image: `${image2}`,
  },
  {
    id: 3,
    name: 'Fatoumata K.',
    city: 'Bamako',
    improvement: '+114%',
    subject: 'français',
    before: '7/20',
    after: '15/20',
    duration: '5 semaines',
    quote: 'Les résultats sont là ! Mon enfant est premier de sa classe maintenant.',
    rating: 5,
    image: `${image1}`,
  },
];

export const STATS = {
  lectureProgress: '92%',
  mathsProgress: '87%',
  familiesCount: '15 000+',
  monthlySuccesses: '2 347',
  weeklyParents: '1 847',
  averageRating: '4.9/5',
  totalReviews: '12 483',
};

export const NEXT_ACTIONS = [
  {
    id: 'test-demo',
    label: 'Lancer le test démo',
    description: 'Découvre le niveau de ton enfant en 5 min',
    badge: 'Débloque le badge "Parent Suiveur"',
    recommended: true,
    route: '/parentProspect/select-enfant',
  },
  {
    id: 'aide-devoirs',
    label: "Commencer l'aide aux devoirs",
    description: 'Vérifier une leçon ou corriger un exercice',
    recommended: false,
    route: '/parentProspect/select-enfant',
  },
  {
    id: 'progres',
    label: 'Suivre les progrès de mes enfants',
    description: 'Accéder au tableau de bord parent',
    recommended: false,
    route: '/parentProspect/select-enfant',
  },
];

// Génération des années de naissance (de 2005 à 2020)
export const BIRTH_YEARS = Array.from(
  { length: 16 },
  (_, i) => 2020 - i
);
